import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import moment from "moment";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";

const Table = ({ ApiData, userType }) => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  const getDevice =(device)=>{
    if(device===1){
        return <Android>Android</Android>
    }else if(device===2){
        return <Ios>Ios</Ios>
    }else{
        return <Web>Web</Web>
    }
  }

  const getcreatedDate = (item) => {
    return (
      <div className="flex gap-3 ">
        <div className="flex flex-col ">
          <span className="text-zinc-900 font-medium">
            {item.createdAt
              ? moment(item.createdAt).format("ll")
              : "---"}
          </span>
          <span className="text-gray-400 text-xs font-medium">
            {item.createdAt
               ? moment(item.createdAt).format("hh:mm A")
               : "---"}
          </span>
        </div>
      </div>
    );
  };

  const getDoneByUserType = (doneByUserType) => {
    if (doneByUserType === 1) {
      return "Client";
    } else if (doneByUserType === 2) {
      return "Tenant";
    } else if (doneByUserType === 3) {
      return "Staff";
    } else {
      return "-";
    }
  };

  const getClientName = (item) => {
    return (
      <div className="flex gap-3">
        <div className="flex flex-col">
          <span className="text-zinc-900 font-medium">
            {item.doneByName}{" "}
          </span>
          <span className="text-gray-400 text-xs">{getDoneByUserType(item.doneByUserType)}</span>
        </div>
      </div>
    );
  };

 const getActivity = (item) => {
  return (
    <div className="text-sm text-zinc-900 leading-6">
      {item.description}
    </div>
  );
};

// const getActivity = (item) => {
//   const description = item?.description || "";
//   const isLongDescription = description.length > 30;

//   return (
//     <div>
//       <div
//         data-tooltip-id={`tooltip-activity-${item.id}`}
//         data-tooltip-content={isLongDescription ? description : ""}
//         data-tooltip-delay-show={1000}
//         data-tooltip-place="top"
//         data-tooltip-variant="info"
//         className="text-sm text-zinc-900 leading-6 truncate cursor-pointer"
//       >
//         {isLongDescription
//           ? description.substring(0, 30) + "..."
//           : description}
//       </div>

//       {isLongDescription && (
//         <Tooltip
//           id={`tooltip-activity-${item.id}`}
//           className="!w-72 sm:!w-96"
//         />
//       )}
//     </div>
//   );
// };

 
  useEffect(() => {
    if (ApiData) {
      setData(
        ApiData.map((item) => ({
          _raw: item,
          date: getcreatedDate(item),
          doneby:getClientName(item),
          platform:getDevice(item.device),
          activity:getActivity(item),

        }))
      );
    }
  }, [ApiData]);


  useEffect(() => {
    const handleResize = () =>
      setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () =>
      window.removeEventListener("resize", handleResize);
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        { Header: "Date", accessor: "date", width: "33%" },
        { Header: "Done By", accessor: "doneby", width: "34%" },
        { Header: "Platform", accessor: "platform", width: "33%" },
      ];
    }

    return [
      { Header: "Date", accessor: "date", width: "20%" },
      { Header: "Done By", accessor: "doneby", width: "20%" },
      { Header: "Platform", accessor: "platform", width: "15%" },
      { Header: "Activity", accessor: "activity", width: "45%" },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    pageOptions,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: {
        pageIndex: currentPage,
        pageSize: PaginationLimit,
      },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}
                   style={{
                      width: column.width,
                      minWidth: column.width,
                      maxWidth: column.width,
                    }}
                >
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          className={ApiData?.length > 0 ? "border-b" : ""}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps()}
                  className={ApiData?.length > 0 ? "border-b" : ""}
                >
                  {row.cells.map((cell, cellIndex) => {
                    // const isActionCell = cell.column.id === "action";
                    return (
                      <Td
                        {...cell.getCellProps()}
                        style={{
                          width: cell.column.width,
                          minWidth: cell.column.width,
                          maxWidth: cell.column.width,
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>

      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page <em>{pageIndex + 1} of {pageOptions.length}</em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={previousPage} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75" />
            </PrevBtn>
            <NextBtn onClick={nextPage} disabled={!canNextPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 rotate-180 opacity-75" />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table`w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(p) => (p.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(p) =>
  p.hasdata === "true" ? "border-b" : ""} hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500 cursor-pointer`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Web = tw.div`text-blue-700 text-xs font-semibold bg-blue-100 border-none border w-9 h-5 flex items-center justify-center rounded-full`;
const Android = tw.div`text-green-700 text-xs font-semibold bg-green-100 border-none border w-14 h-5 flex items-center justify-center rounded-full`;
const Ios = tw.div`text-red-700 text-xs font-semibold bg-red-100 border-none border w-9 h-5 flex items-center justify-center rounded-full`;
export default Table;


